import React, { useState, useCallback, useMemo } from "react";
import nodeinstance from "../../../../../nodeInstance";
import UpdatePopIqama from "./updatePopUp";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import UploadExpiryDate from "./UploadExpiryPopUp";
import SmartDownloadPagination from "../../../../../components/SmartDataTable/SmartDownloadPagination";

export default function IqammaUpdate() {
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [viewExpiry, setViewExpiry] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const columns = useMemo(() => [
    { key: "sno", title: "S.NO.", sortable: false },
    { key: "selection", title: "SELECT", sortable: false },
    { key: "emp_id", title: "EMPLOYEE ID" },
    { key: "sadaad_notes", title: "SADAAD NOTES" },
    { key: "actual_profession", title: "ACTUAL PROFESSION" },
    { key: "nationality", title: "NATIONALITY" },
    { key: "visa_provider", title: "VISA PROVIDER" },
    { key: "sponsor_id", title: "SPONSOR ID" },
    { key: "client", title: "CLIENT NAME" },
    { key: "iqama_number", title: "IQAMA NUMBER" },
    { key: "iqama_received_date", title: "IQAMA RECEIVED DATE" },
    { key: "iqama_issue_date", title: "IQAMA ISSUE DATE" },
    { key: "iqama_expiry_date_g", title: "IQAMA EXPIRY DATE (G)" },
    { key: "iqama_expiry_date_h", title: "IQAMA EXPIRY DATE (H)" },
    { key: "iqama_aging_days", title: "AGING DAYS" },
    { key: "iqama_valid_days", title: "VALID DAYS" },
    { key: "tenure", title: "TENURE" },
    { key: "renewal_request_date", title: "RENEWAL REQUEST DATE" },
    { key: "renewal_authorization_date", title: "RENEWAL AUTHORIZATION DATE" },
    { key: "sadaad_generation_date", title: "SADAAD GENERATION DATE" },
    { key: "sadaad_payment_date", title: "SADAAD PAYMENT DATE" },
    { key: "status", title: "STATUS" },
  ], []);

  const handleStandaloneSearch = async (term) => {
    if (!term) return;
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await nodeinstance.get(
        `/iqama/getFilterByEmployeeId/${term}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data) {
        setSearchData(response.data.data || []);
      }
    } catch (error) {
      dispatch(setAppError({ msg: "Search failed: " + error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setIsSearchActive(false);
      setSearchData(null);
    }
  };

  const handleSelectionChange = useCallback((emp_id, isChecked, row) => {
    setSelectedIds((prev) => {
      if (isChecked) return [...prev, emp_id];
      return prev.filter((id) => id !== emp_id);
    });
    setSelectedRows((prev) => {
      if (isChecked) return [...prev, row];
      return prev.filter((r) => r.emp_id !== emp_id);
    });
  }, []);

  const renderCustomCell = (item, column) => {
    if (column.key === "selection") {
      return (
        <input
          type="checkbox"
          checked={selectedIds.includes(item.emp_id)}
          onChange={(e) => handleSelectionChange(item.emp_id, e.target.checked, item)}
        />
      );
    }
    if (column.key === "status") {
      return item.iqama_status_value?.toString() === "5"
        ? "Iqama Tenure Pending"
        : item.iqama_status || "-";
    }
    if (column.key === "sadaad_notes") {
      return (
        <div className="max-w-[250px]">
          <span className="line-clamp-2" title={item.sadaad_notes}>
            {item.sadaad_notes || "-"}
          </span>
        </div>
      );
    }
    return null;
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/iqama/downloadIqamaExpiryTemplate`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Iqama_Expiry_Template.xlsx`);
        document.body.appendChild(link);
        link.click();
        dispatch(setAppError({ msg: "Excel Downloaded", color: "success" }));
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(setAppError({ msg: err.message }));
    } finally {
      setDownloadLoading(false);
    }
  };

  const apiCall = () => {
    setSelectedIds([]);
    setSelectedRows([]);
    setTrigger(prev => !prev);
  };

  const additionalActions = useMemo(() => [
    {
      label: "Upload",
      onClick: () => setViewExpiry(true),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: downloadLoading ? "Downloading..." : "Download Template",
      onClick: downloadFile,
      disabled: downloadLoading,
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "Update Expiry",
      onClick: () => {
        if (selectedIds.length === 0) {
          dispatch(setAppError({ msg: "Please select Check box" }));
        } else {
          setPopUpOpen(true);
        }
      },
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "Clear filter",
      onClick: () => {
        setIsSearchActive(false);
        setSearchData(null);
      },
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    }
  ], [selectedIds, downloadLoading]);

  return (
    <>
      <div className="mt-4">
        <SmartDownloadPagination
          apiEndpoint="/iqama/iqammaDone/IqamaExpiry"
          token={token}
          columns={columns}
          layoutType="table"
          additionalActions={additionalActions}
          renderCustomCell={renderCustomCell}
          searchPlaceholder={"Search employee id..."}
          defaultPageSize={50}
          pageSizeOptions={[10, 50, 100, 500, 1000]}
          trigger={trigger}
          onSearchClick={handleStandaloneSearch}
          onSearchChange={handleSearchChange}
          manualData={isSearchActive ? searchData : null}
          enableDownload={false}
        />
      </div>

      {popUpOpen && (
        <UpdatePopIqama
          popUpOpen={popUpOpen}
          setPopUpOpen={setPopUpOpen}
          propData={selectedRows}
          callBack={apiCall}
        />
      )}
      {viewExpiry && (
        <UploadExpiryDate
          View={viewExpiry}
          setView={setViewExpiry}
          url={"/iqama/uploadIqamaExpiry"}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      )}
    </>
  );
}
